import { render, staticRenderFns } from "./DialogHost.vue?vue&type=template&id=572d8a2a"
import script from "./DialogHost.vue?vue&type=script&lang=js"
export * from "./DialogHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports